import { useMemo } from 'react';
import { useCollectionListener } from '@framework/repository';
import { GroupMemberInvitation } from '@group/domain';
import { RTDBPath } from 'balus-common';

export const useGroupMemberInvitations = (groupId: string): GroupMemberInvitation[] | null => {
  const invitations = useCollectionListener(GroupMemberInvitation, RTDBPath.Group.memberInvitationsPath(groupId));
  return useMemo(() => {
    if (!invitations) return null;
    return invitations.sort(GroupMemberInvitation.compareByCreatedAt).reverse();
  }, [invitations]);
};
